import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    token: db.get('USER_TOKEN'),
    expireTime: db.get('EXPIRE_TIME'),
    refreshToken: db.get('REFRESH_TOKEN'),
    refreshTokenExpireTime: db.get('REFRESH_EXPIRE_TIME'),
    user: db.get('USER'),
    permissions: db.get('PERMISSIONS'),
    roles: db.get('ROLES')
  },
  mutations: {
    setToken (state, val) {
      db.save('USER_TOKEN', val)
      state.token = val
    },
    setExpireTime (state, val) {
      db.save('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setRefreshToken (state, val) {
      db.save('REFRESH_TOKEN', val)
      state.refreshToken = val
    },
    setRefreshTokenExpireTime (state, val) {
      db.save('REFRESH_EXPIRE_TIME', val)
      state.refreshTokenExpireTime = val
    },
    setUser (state, val) {
      db.save('USER', val)
      state.user = val
    },
    setPermissions (state, val) {
      db.save('PERMISSIONS', val)
      state.permissions = val
    },
    setRoles (state, val) {
      db.save('ROLES', val)
      state.roles = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js